document.addEventListener('DOMContentLoaded', () => {
  const paperSizeSelect = document.getElementById('label_dimension_paper_size');
  if (!paperSizeSelect) return;

  const paperWidthInput = document.getElementById('label_dimension_paper_width');
  if (!paperWidthInput) return;

  const paperHeightInput = document.getElementById('label_dimension_paper_height');
  if (!paperHeightInput) return;

  paperSizeSelect.onchange = () => {
    if (paperSizeSelect.selectedIndex === 0) {
      paperHeightInput.removeAttribute('disabled');
      paperWidthInput.removeAttribute('disabled');
    } else {
      paperHeightInput.setAttribute('disabled', '');
      paperWidthInput.setAttribute('disabled', '');

      const paperSize = paperSizeSelect.options[paperSizeSelect.selectedIndex].value;

      paperWidthInput.value = PaperSizes[paperSize][0];
      paperHeightInput.value = PaperSizes[paperSize][1];
    }
  };
}, false);
